import React from 'react';
import {useTranslation} from "@Translation/hooks/useTranslation";
import useQuantityAwareTranslation from "@Translation/hooks/useQuantityAwareTranslation";
import NextDeparturesRows from "@Pages/stationPage/components/NextDeparturesRows";

interface NextDeparturesProps {
    nextDepartures: any[],
    stationName: string,
}

function NextDepartures({nextDepartures, stationName}: NextDeparturesProps) {
    const noteLabel = useQuantityAwareTranslation("sys.note", 1).toUpperCase()
    const noResultsTitleLabel = useTranslation("no_res.no_results_title")
    const nextDeparturesLabel = useTranslation(
        "p_page.next_departures",
        {'%stationName%': stationName}
    )
    const otherFerryConnectionsNoteLabel = useTranslation("p_page.other_ferry_connections_note")

    if (!nextDepartures.length) {
        return (
            <div className="gb--notification gb--notification-blue gb--notification-large">
                <b>
                    {noteLabel}
                    :
                </b>
                {noResultsTitleLabel}
            </div>
        );
    }

    return (
        <>
            <hr/>
            <h2 id="h--next-departures">
                {nextDeparturesLabel}
            </h2>
            <NextDeparturesRows
                nextDepartures={nextDepartures}
            />
            <div className="gb--notification gb--notification-green gb--notification-large">
                <b>
                    {noteLabel}
                    :
                </b>
                {otherFerryConnectionsNoteLabel}
            </div>
        </>
    );
}

export default NextDepartures;